import { h } from "@stencil/core";

export const Check = (className: string) => (
    <svg class={className} viewBox="0 0 32 32" role="img" fill="currentColor">
        <path d="M20.256 13.152c-2.848 4.704-5.376 8.832-5.6 9.216l-0.448 0.672-7.2-7.232-2.496 2.496 5.248 5.248c3.2 3.2 5.28 5.216 5.344 5.12 0.192-0.192 13.536-22.56 13.504-22.624-0.16-0.128-2.88-1.44-3.008-1.44-0.096 0-2.496 3.84-5.344 8.544"></path>
    </svg>
);

export const CheckboxMixed = (className: string) => (
    <svg class={className} viewBox="0 0 32 32" role="img" fill="currentColor">
        <path d="M6.016 7.328h20v17.344h-20v-17.344zM9.344 10.656v10.688h13.312v-10.688h-13.312z"></path>
    </svg>
);
